// react
import { useState, useContext, useRef } from "react"
import { useHistory } from "react-router-dom"
// helpers
import { UserContext } from "../store/store"
// componentes
import Container from "../components/ui/Container.js"
// css
import "./Login.scss"
// cookies
import { setCookie } from "../helpers/cookies"
import { parseJwt } from "../helpers/jwt"
import { api } from "../services/api"

const Login = () => {
  const [state, dispatch] = useContext(UserContext),
    nameEl = useRef(),
    passEl = useRef(),
    [data, setData] = useState(null),
    [isPending, setIsPending] = useState(false),
    [err, setErr] = useState(null),
    history = useHistory()

  const showErr = (err) => {
    setIsPending(false)
    setErr(err.message)

    setTimeout(() => {
      setErr(false)
    }, 3000)
  }

  const showData = (data, username) => {
    setData(data)
    setIsPending(false)
    setErr(null)

    let jwt = data.access_token,
      tkn = parseJwt(jwt)

    setCookie("jwt", jwt, 30)
    setCookie("username", username, 30)
    setCookie("role", tkn.role, 30)

    dispatch({
      type: "SET_LOGIN",
      payload: {
        jwt: data.access_token,
        usr: {
          name: username,
          role: tkn.role,
        },
      },
    })

    history.push("/")
  }

  const handleLogin = async (e) => {
    e.preventDefault()
    setIsPending(true)

    let username = nameEl.current.value,
      rawPassword = passEl.current.value

    const { url, opt } = await api.token.newToken({ username, rawPassword })

    fetch(url, opt)
      .then((res) => {
        if (!res.ok) throw Error("could not fetch")
        return res.json()
      })
      .then((data) => showData(data, username))
      .catch((err) => showErr(err))
  }

  if (state.jwt) return <h1>Ya estas logeado {state.usr.name}</h1>

  return (
    <Container>
      <div className="mini-container">
        <center>
          <h2>Ingresar</h2>
        </center>
        <form>
          {isPending && <b>Waiting...</b>}
          {data && (
            <b>me llego: {JSON.stringify(parseJwt(data.access_token))}</b>
          )}
          <input ref={nameEl} type="email" placeholder="Username" />

          <input ref={passEl} type="password" placeholder="password" />

          {err && (
            <div className="alert danger">
              ❌ &nbsp; Las credenciales no coinciden
            </div>
          )}

          {isPending ? (
            <button
              id="login-btn"
              className="btn lg azul"
              type="submit"
              disabled
            >
              Enviando...
            </button>
          ) : (
            <button
              id="login-btn"
              className="btn lg azul"
              type="submit"
              onClick={handleLogin.bind(this)}
            >
              Ingresar
            </button>
          )}
        </form>
      </div>
    </Container>
  )
}

export default Login
